import { createSlice } from "@reduxjs/toolkit"

export const activeAdsSlice = createSlice({
	name: "active_ads",
	initialState: {
		activeAds: "",
		errors: [],
	},

	reducers: {
        getActiveAds: (state, action) => {
          
			state.activeAds = action.payload
		},
		getActiveAdsList: (state, action) => {
           
			state.activeAds = action.payload
		},
		getErrors: (state, action) => {
          
			state.errors = action.payload
		},
	},
})
export const {getActiveAds, getActiveAdsList, getErrors} = activeAdsSlice.actions

export default activeAdsSlice.reducer
